<div class="d-inline-block">
  <img *ngIf="imageSource; else text" [src]="imageSource" [alt]="brand" class="credit-card" />
  <ng-template #text>{{ brand }}</ng-template>
</div>
